import { render } from "./budget_information_profitAndLossStructures.vue?vue&type=template&id=46cbd83e"
import script from "./budget_information_profitAndLossStructures.vue?vue&type=script&lang=js"
export * from "./budget_information_profitAndLossStructures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__